import { axiosGetHandler, axiosPostHandler } from "./config";
import { extractAPIValues } from "_lib/utils/utils";
import store from "@/store";

const { BASE_API } = extractAPIValues();

// 获取游戏进程列表
export const getGameProcessList = (params) => {
  const url = BASE_API + "/chatroom/v2/account/user_games";
  return axiosGetHandler(url, params);
};

// 更新用户游戏进程信息
export const updateGameProcessInfo = (params, data) => {
  const url = BASE_API + "/chatroom/v2/account/game/update";
  return axiosPostHandler(url, params, data);
};

//游戏状态上报
export const reportGameStatus = (params, data, force) => {
  let formDataString = JSON.stringify(data);
  if (!force && window._user_game_state === formDataString) {
    return;
  }
  window._user_game_state = formDataString;
  const url = BASE_API + "/chatroom/v2/account/game/state";
  return axiosPostHandler(url, params, data);
};

// 更新显示状态
export const updateShowStatus = (params, data) => {
  const url = BASE_API + "/chatroom/v2/account/game/show";
  return axiosPostHandler(url, params, data);
};

// 申请认证
export const applyCertification = (params, data) => {
  const url = BASE_API + "/chatroom/v2/account/game/certification";
  return axiosPostHandler(url, params, data);
};

// 删除记录
export const removeProcessInfo = (params, data) => {
  const url = BASE_API + "/chatroom/v2/account/game/delete";
  return axiosPostHandler(url, params, data);
};

// 游戏进程配置游戏内覆盖
export const gameOverlayConfig = (params, data) => {
  const url = BASE_API + '/chatroom/v2/account/game/overlay'
  return axiosPostHandler(url, params, data)
}